// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:07:27.358Z
// Property: Fresco (ID: 6767906449167142)
// Collections: 37 amenities, 3 floorplans (live), 23 photos, 36 POIs, 2 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167142",
  "property_external_id": "872258",
  "property_zillow_url": "https://www.zillow.com/apartments/moreno-valley-ca/fresco/5XjW29/",
  "property_apartments_url": "https://www.apartments.com/fresco-moreno-valley-ca/dxr97ph/",
  "property_google_business_url": "https://www.google.com/maps/place/Fresco+Apartment+Homes/data=!4m2!3m1!1s0x0:0xfff5176b3281444a?sa=X&ved=2ahUKEwj9j7GA1YOTAxV6g2oFHV_WEoMQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47723982655",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fresco",
  "property_name": "Fresco",
  "property_website_url": "https://www.frescoapthomes.com",
  "property_domain": "https://www.frescoapthomes.com",
  "property_address": "12640 Memorial Way",
  "property_full_address": "12640 Memorial Way, Moreno Valley, CA, 92553",
  "property_address_1": "12640 Memorial Way",
  "property_address_2": null,
  "property_address_city": "Moreno Valley",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "92553",
  "property_address_country": "US",
  "property_address_county": "Riverside County",
  "property_neighborhood_address": "Moreno Valley West",
  "property_address_latitude": "33.9357",
  "property_address_longitude": "-117.2702",
  "property_email": "fresco@weidner.com",
  "property_phone": "9516219315",
  "property_call_tracking_phone": "951-867-4787",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Fresco, where modern comfort meets vibrant living in Moreno Valley, CA. Choose from spacious one, two, or three-bedroom floor plans, each featuring inviting amenities—from our resort-style pools and fitness center to a pet-friendly play area and clubhouse. Your ideal home awaits! ",
  "property_long_description": "Welcome to Fresco, your premier apartment community in the heart of Moreno Valley, CA, where comfort meets luxury! Our thoughtfully designed floor plans feature one, two, and three-bedroom options, perfect for any lifestyle. Enjoy the best of both worlds with our spacious interiors, complete with features such as elegant crown molding, vaulted ceilings, and luxurious Roman soaking tubs — available in select homes.\n\nAt Fresco, we believe in providing an unparalleled living experience. Our extensive amenities cater to your every need. From controlled access and a dedicated concierge services to a fully equipped business center and beautifully appointed clubhouse, we have it all! Dive into relaxation with two resort-style pools and hydrotherapy spas, or unwind in our resident lounge and game room. If fitness is a priority, our well-equipped fitness center will not disappoint.\n\nPet lovers will find joy in our pet play area, while families can take advantage of our playground and planned social activities. For convenience, we offer furnished units, on-site maintenance, and 24-hour private electronic access. Plus, with a smoke-free environment, you can live comfortably and healthily.\n\nDiscover the vibrant lifestyle that awaits at Fresco. Whether you're hosting a barbecue in our cabana or enjoying a picnic under the sun, our community is designed for both relaxation and connection. \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Experience all that Fresco has to offer and elevate your living in Moreno Valley!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d08c1-c522-7788-8d99-11d28c783d9a.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex with a large swimming pool and lounge chairs",
    "public_id": "019d08c1-c522-7788-8d99-11d28c783d9a",
    "storage_key": "property/6767906449167142/019d08c1-c522-7788-8d99-11d28c783d9a.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "552",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": "78",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.36956521739131",
  "property_admin_fee": null,
  "property_application_fee": "55",
  "property_fees_deposit_info": "600-900",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome (no weight limit). Maximum 2 pets per unit. Monthly pet rent: $50 per pet. Refundable pet deposit: $500 for first pet, $300 for second pet. Breed restrictions apply (e.g., Pit Bull & mixes, Rottweiler, German Shepherd, etc.).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://frescoapthomes.securecafe.com/onlineleasing/fresco/floorplans.aspx",
  "property_resident_portal_url": "https://frescoapthomes.securecafenet.com/residentservices/fresco/userlogin",
  "property_apply_now_url": "https://frescoapthomes.securecafe.com/onlineleasing/fresco/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d08c1-d227-756b-a9e2-8e8d22ae23ae.webp",
  "property_primary_logo_media": {
    "alt_text": "Fresco Apartment Homes logo",
    "public_id": "019d08c1-d227-756b-a9e2-8e8d22ae23ae",
    "storage_key": "property/6767906449167142/019d08c1-d227-756b-a9e2-8e8d22ae23ae.webp",
    "width": 299,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d08c1-dd81-70d6-b516-f4663237a5b3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fresco Apartment Homes logo",
    "public_id": "019d08c1-dd81-70d6-b516-f4663237a5b3",
    "storage_key": "property/6767906449167142/019d08c1-dd81-70d6-b516-f4663237a5b3.webp",
    "width": 299,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d08c1-e6a8-7674-bfbd-b6e39cff146a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Fresco Apartment Homes logo",
    "public_id": "019d08c1-e6a8-7674-bfbd-b6e39cff146a",
    "storage_key": "property/6767906449167142/019d08c1-e6a8-7674-bfbd-b6e39cff146a.webp",
    "width": 299,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#2a2c30",
  "property_secondary_color": "#868f72",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#b9c6d3",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "803 - 1233",
  "property_sqft_min": "803",
  "property_sqft_max": "1233",
  "property_price_range": "1895 - 2919",
  "property_price_min": "1895",
  "property_price_max": "2919",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/FrescoApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/frescoapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmckZf1Wv3IARSkSBMmsX9f8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fresco",
  "property_home_romance_title": "Embrace Cozy Living in Your New Dream Home Today",
  "property_home_amenities_blurb": "Experience the vibrant lifestyle at Fresco in Moreno Valley, CA, where modern elegance meets comfort. Our spacious one, two, and three-bedroom apartments feature exceptional amenities, including resort-style pools, a state-of-the-art fitness center, and a welcoming clubhouse. Enjoy the perfect blend of relaxation and recreation—your sanctuary awaits!",
  "property_home_floorplans_blurb": "At Fresco in Moreno Valley, CA, our thoughtfully designed apartment homes offer a blend of comfort and style, tailored to every lifestyle. From cozy studios to spacious two-bedroom layouts, each floor plan invites you to envision your ideal living space. Browse our available apartments today and find your perfect fit!",
  "property_home_gallery_blurb": "At Fresco in Moreno Valley, comfort meets luxury. Choose from spacious one, two, or three-bedroom floor plans, each designed for your lifestyle. Enjoy exceptional amenities like resort-style pools, a fully equipped fitness center, and a vibrant community atmosphere. Picture yourself living here, where every detail caters to your every need!",
  "property_home_neighborhood_blurb": "Welcome to Fresco, your oasis in Moreno Valley, CA! Enjoy spacious floor plans—from one to three bedrooms—while living steps from local attractions like the Moreno Valley Mall, University of California Riverside, and parks perfect for outdoor recreation. Experience vibrant community living with endless opportunities for adventure and relaxation!",
  "property_home_reviews_blurb": "At Fresco in Moreno Valley, CA, residents rave about the “peaceful atmosphere and friendly neighbors” that define our vibrant community. Enjoy top-tier amenities and a welcoming environment that truly feels like home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Moreno Valley, Fresco offers vibrant living with a rich tapestry of nearby attractions. Enjoy leisurely days at Sycamore Highlands Park or immerse yourself in local culture at March Field Air Museum. With premier educational institutions and fitness centers nearby, life here is both fulfilling and convenient.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Fresco in Moreno Valley, your ideal living experience awaits. Enjoy amenities like resort-style pools, a state-of-the-art fitness center, and on-site concierge service—all within beautifully appointed, spacious apartments. From pet play areas to planned social activities, life here is crafted for comfort and community. Embrace the extraordinary!",
  "property_applynow_blurb": "Welcome to Fresco in Moreno Valley, CA, where luxury meets convenience. Choose from spacious one, two, and three-bedroom floor plans, all with modern amenities like controlled access, resort-style pools, and a fully equipped fitness center. Embrace the lifestyle you deserve—lease your new home online today!",
  "property_contactus_blurb": "At Fresco in Moreno Valley, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Whether you seek cozy elegance or spacious comfort, our community has the perfect home waiting for you. Have questions? Contact our leasing team today and let’s find your ideal space!",
  "property_faqs_blurb": "At Fresco in Moreno Valley, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Curious about life here? Our FAQs page is packed with insights to help you navigate our vibrant community. Dive in and find the answers you need today!",
  "property_floorplans_blurb": "At Fresco in Moreno Valley, CA, your ideal living space awaits. Choose from stylish one, two, or three-bedroom floor plans designed with comfort and flair. Elevate your lifestyle—browse our available apartment homes today and uncover the perfect layout that complements your unique needs and aspirations.",
  "property_gallery_blurb": "Welcome to Fresco in Moreno Valley, CA, where modern luxury meets comfort. Choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Indulge in resort-style amenities, including two sparkling pools, a vibrant clubhouse, and serene picnic areas. Picture yourself living here and experiencing a vibrant community!",
  "property_interactivemap_blurb": "Welcome to Fresco, Moreno Valley's hidden gem! Embrace luxury living with spacious one, two, and three-bedroom apartments featuring state-of-the-art amenities like resort-style pools, a fitness center, and a pet play area. Navigate your future home effortlessly using our interactive community map—your dream apartment awaits!",
  "property_pets_blurb": "At Fresco in Moreno Valley, CA, your furry companions can feel right at home! With no weight limits and a friendly pet policy, bring along your cats and dogs to enjoy spacious living. Embrace the vibrant community and scenic surroundings tailored for both you and your beloved pets.",
  "property_referafriend_blurb": "At Fresco in Moreno Valley, CA, great friends become great neighbors! With spacious one-, two-, and three-bedroom floor plans, your perfect home awaits. Spread the joy of community living—refer a friend today and enjoy the benefits of having someone special by your side!",
  "property_residentaccess_blurb": "Welcome to Fresco in Moreno Valley, CA, where your perfect home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored to suit your lifestyle. Access your resident portal for seamless rent payments, maintenance requests, and more—making life at Fresco as convenient as it is comfortable.",
  "property_reviews_blurb": "At Fresco in Moreno Valley, CA, residents rave about their experience: \"The staff is incredibly friendly, and the community feels like home.\" Dive into our reviews to find out why living here is more than just a place to stay—it's a vibrant lifestyle. See what our residents have to say!",
  "property_created_at": "1771530137363",
  "property_scheduletour_blurb": "At Fresco in Moreno Valley, CA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle needs. Step into a vibrant community where comfort meets convenience. Curious about life at Fresco? Hear directly from our residents and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Fresco in Moreno Valley, CA! We’re thrilled to showcase our diverse floor plans, including one, two, and three-bedroom options. A member of our team will be in touch soon to help you find your perfect home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "Step into Fresco in Moreno Valley, CA, where stylish living meets modern comfort. Our diverse floor plans—one, two, and three-bedroom options—cater to every lifestyle. Experience our vibrant community firsthand; take a virtual tour and envision the lifestyle you've always dreamed of! Your new home awaits.",
  "property_copyright": "2026 All Rights Reserved. Fresco",
  "property_seo_title_home": "Fresco |  Apartments in Moreno Valley, CA",
  "property_seo_description_home": "Experience luxury living at Fresco in Moreno Valley! Enjoy spacious 1-3 bedroom apartments and resort-style amenities. Your dream home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Moreno Valley, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Fresco in Moreno Valley. From cozy one-bedrooms to spacious three-bedrooms, browse our floor plans and feel at home today!",
  "property_seo_title_amenities": "Amenities | Moreno Valley, CA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Fresco in Moreno Valley! Enjoy luxe amenities like pools, a fitness center, and cozy fireplaces—your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Moreno Valley, CA",
  "property_seo_description_gallery": "Envision your life at Fresco in Moreno Valley. With stunning amenities, spacious floor plans, and a vibrant community, your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Fresco Apartments",
  "property_seo_description_virtualtours": "Experience Fresco in Moreno Valley! Take a virtual tour of our stylish one, two, and three-bedroom apartments—your new home awaits!✨",
  "property_seo_title_interactivemap": "Interactive Map | Fresco Apartments",
  "property_seo_description_interactivemap": "Find your ideal apartment at Fresco in Moreno Valley! Use our interactive map to view layouts, pricing, and amenities. Your perfect home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Moreno Valley, CA",
  "property_seo_description_neighborhood": "Experience Moreno Valley living at Fresco! Uncover local gems and vibrant spots near our welcoming community. Your ideal home and neighborhood await!",
  "property_seo_title_contact": "Contact Us | Fresco",
  "property_seo_description_contact": "Connect with our leasing team at Fresco in Moreno Valley, CA! Inquire about our one, two, and three-bedroom floor plans tailored for your lifestyle today!",
  "property_seo_title_faqs": "FAQs | Apartments in Moreno Valley, CA",
  "property_seo_description_faqs": "Unlock answers to your questions about Fresco in Moreno Valley. From amenities to floor plans, check out our FAQs and embrace your perfect living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Moreno Valley, CA",
  "property_seo_description_reviews": "Discover life at Fresco in Moreno Valley! Enjoy luxury amenities, spacious floor plans, and a vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Moreno Valley, CA",
  "property_seo_description_applynow": "Experience luxury living at Fresco in Moreno Valley! Choose from spacious 1, 2, or 3-bedroom apartments with top-notch amenities.",
  "property_seo_title_residentaccess": "Resident Access | Fresco",
  "property_seo_description_residentaccess": "Log in to Fresco's resident portal in Moreno Valley! Manage rent, request maintenance, and connect with your community—all at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | Fresco",
  "property_seo_description_referafriend": "Refer a friend to Fresco in Moreno Valley! Enjoy vibrant living with great neighbors. Share the experience and elevate your community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Fresco",
  "property_seo_description_scheduletour": "Experience modern living at Fresco in Moreno Valley, CA! Tour your future home today and discover a vibrant community that suits your lifestyle. Schedule now!",
  "property_seo_title_privacy": "Privacy Policy | Fresco",
  "property_seo_description_privacy": "Safeguarding your peace of mind, Fresco in Moreno Valley, CA values your privacy. Dive into our policy to learn how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Fresco",
  "property_seo_description_accessibility": "Experience inclusive living at Fresco in Moreno Valley. Our commitment to accessibility ensures everyone feels at home. Your comfort is our priority!",
  "property_seo_title_sitemap": "Sitemap | Fresco",
  "property_seo_description_sitemap": "Navigate your way through Fresco in Moreno Valley, CA! Check out our sitemap to easily explore floor plans, amenities, and everything our community offers.",
  "property_seo_title_thankyou": "Thank You | Fresco",
  "property_seo_description_thankyou": "Thank you for sharing your info with Fresco in Moreno Valley. Our team will be in touch soon to help you find your perfect home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Moreno Valley, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293661224",
  "amenities": [
    {
      "id": "ec_0ea734db522a69db6fb3acb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259142",
      "title": "Covered - Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d9a37-bc54-741a-9d16-e0e9f94fb489.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking lot with cars parked under a long, covered structure in front of an apartment building.",
        "public_id": "019d9a37-bc54-741a-9d16-e0e9f94fb489",
        "storage_key": "property/6767906449167142/019d9a37-bc54-741a-9d16-e0e9f94fb489.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "the enclave at homecoming terra vista parking lot",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bca84ec8d587cc81d675f83b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259144",
      "title": "Garage - Single Car",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d9a37-bc08-7759-b8c7-4a75a8e6b16b.webp",
      "amenity_image_media": {
        "alt_text": "Dark garage doors on a building with a 'No Parking Fire Lane' sign.",
        "public_id": "019d9a37-bc08-7759-b8c7-4a75a8e6b16b",
        "storage_key": "property/6767906449167142/019d9a37-bc08-7759-b8c7-4a75a8e6b16b.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a garage door with a no parking sign on it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_307a360f1c05aaabd8dcb56e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259159",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-4912-7133-8abe-17066ba2d9fd.webp",
      "amenity_image_media": {
        "alt_text": "Playground equipment with slides and swings in front of apartment buildings.",
        "public_id": "019d0217-4912-7133-8abe-17066ba2d9fd",
        "storage_key": "property/6767906449167142/019d0217-4912-7133-8abe-17066ba2d9fd.webp",
        "width": 3072,
        "height": 2049
      },
      "amenity_image_alt_text": "our apartments offer a playground for your little ones",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_064a49745c46d8fb719eef11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259162",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-2d80-7105-a05f-9696bc1c17d5.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills and weight machines in a modern fitness center.",
        "public_id": "019d0217-2d80-7105-a05f-9696bc1c17d5",
        "storage_key": "property/6767906449167142/019d0217-2d80-7105-a05f-9696bc1c17d5.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a gym with cardio equipment and a view of the beach",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c166c1b825e8b8ec38a1934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259163",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d9a37-bb51-74f8-931a-e260bb0a0512.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with palm trees and lounge chairs.",
        "public_id": "019d9a37-bb51-74f8-931a-e260bb0a0512",
        "storage_key": "property/6767906449167142/019d9a37-bb51-74f8-931a-e260bb0a0512.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "our apartments offer a swimming pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90de94670a879923f3ab36ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259164",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d9a37-be0c-778e-9e5e-2005bf2b94b9.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and spa area with palm trees and lounge chairs.",
        "public_id": "019d9a37-be0c-778e-9e5e-2005bf2b94b9",
        "storage_key": "property/6767906449167142/019d9a37-be0c-778e-9e5e-2005bf2b94b9.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a resort style swimming pool with chaise lounge chairs and palm trees",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77f2be8f5e7c193cbe16c9ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259154",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_240d0f21a9fa8e90c728338b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259145",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_968d6546bbf25b78bf3197f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259146",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25c101188b2c90e9942d3710",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259147",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac0c910ea33f266c2d56b558",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259149",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_059784f503da2abd25d09e89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259151",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a373ccffdd0c1b3f1df962f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259158",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e479622dc93948eca08ce0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259161",
      "title": "Cabana/ Gazebo",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-6354-71ec-a7b2-f6e498146418.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor pool area with seating, umbrellas, and grills.",
        "public_id": "019d0217-6354-71ec-a7b2-f6e498146418",
        "storage_key": "property/6767906449167142/019d0217-6354-71ec-a7b2-f6e498146418.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Fresco Pool Cabana Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7223f0db30fdfa6d1ee17ad3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259157",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_438d66e737071e3162440ea6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259160",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68c987b01a2828e1ce6f6c08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259143",
      "title": "Surface Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5bfe68b850e52d193a6d690",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259150",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60b62d81267fc850b5dc2708",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259152",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e278505a1e6a1a337057776",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259155",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b35167f46cef7574f79bfdfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259156",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82f3999b91ec6509577390bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "124800189",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_526fef20309ab2048f61da5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259179",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-0e7d-71d0-a82b-75dfe89706b0.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a large bed and a view into the bathroom and closet.",
        "public_id": "019d0217-0e7d-71d0-a82b-75dfe89706b0",
        "storage_key": "property/6767906449167142/019d0217-0e7d-71d0-a82b-75dfe89706b0.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a bedroom with a bed and a dresser in a room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b065ef55c49c1c4dd4ed7a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259169",
      "title": "White Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-0bea-74ae-9d1d-9681c92ea80e.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d0217-0bea-74ae-9d1d-9681c92ea80e",
        "storage_key": "property/6767906449167142/019d0217-0bea-74ae-9d1d-9681c92ea80e.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a kitchen with a white refrigerator freezer next to a white stove top oven",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_824acd70ba4cb8c464111a62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259171",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c72b4602203f31fedf11665",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259170",
      "title": "Electric Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2a18c8238629b809ca4fc9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259166",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60ace049f28b2aab3f0e59f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259167",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36d9ad00db87394effedbbb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259173",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9f1bc42ebdb58159b6beaf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259174",
      "title": "Fireplace in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac551a894bf9e1b9e8bcb20e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259175",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_599da549dcbd4f483f0a5256",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259176",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9e48672eeba3b125816a566",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259168",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f24c29846d9c23ee31e398c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259172",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58ee7106d03caed66b94f2bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259177",
      "title": "Built-In Office/Desk",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fa6c18d2d28b9f03abd256e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259178",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72c471dfdfd0b8c85aef0e13",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "yardi",
      "external_id": "86259180",
      "title": "Crown Molding in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_717482c93b366cff50ba9e5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0216-ff81-7623-8b24-22f338b36256.webp",
      "image_media": {
        "alt_text": "Living room with a large TV, sofa, coffee table, and a balcony.",
        "public_id": "019d0216-ff81-7623-8b24-22f338b36256",
        "storage_key": "property/6767906449167142/019d0216-ff81-7623-8b24-22f338b36256.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpeting, a flat-screen TV, and access to a private balcony.",
      "link": "false",
      "alt_text": "Living room with a large TV, sofa, coffee table, and a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (1).jpg"
    },
    {
      "id": "ec_817e837d10785bba5fef377e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-0158-7435-9646-2a7f623b6399.webp",
      "image_media": {
        "alt_text": "Dining area and workspace with a glass table, chairs, and a desk with a refrigerator.",
        "public_id": "019d0217-0158-7435-9646-2a7f623b6399",
        "storage_key": "property/6767906449167142/019d0217-0158-7435-9646-2a7f623b6399.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a versatile living space with a dedicated dining area and a functional workspace, complemented by modern appliances for your convenience.",
      "link": "false",
      "alt_text": "Dining area and workspace with a glass table, chairs, and a desk with a refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (2).jpg"
    },
    {
      "id": "ec_a8b8c7e5144d2698ac09b849",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0216-ff79-747a-b6bb-ffc209a2e67f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white appliances including a refrigerator, stove, and microwave.",
        "public_id": "019d0216-ff79-747a-b6bb-ffc209a2e67f",
        "storage_key": "property/6767906449167142/019d0216-ff79-747a-b6bb-ffc209a2e67f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and functional kitchen featuring ample cabinet space, a refrigerator, stove, microwave, and a double sink, perfect for everyday cooking.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, white appliances including a refrigerator, stove, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (3).jpg"
    },
    {
      "id": "ec_58bdf1c733da42dd3a9a4e2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-0bea-74ae-9d1d-9681c92ea80e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d0217-0bea-74ae-9d1d-9681c92ea80e",
        "storage_key": "property/6767906449167142/019d0217-0bea-74ae-9d1d-9681c92ea80e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen featuring ample cabinet space, modern appliances, and a sleek granite countertop, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (4).JPG"
    },
    {
      "id": "ec_fe6dee9f0c370d0330f29b05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-0e7d-71d0-a82b-75dfe89706b0.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed and a view into the bathroom and closet.",
        "public_id": "019d0217-0e7d-71d0-a82b-75dfe89706b0",
        "storage_key": "property/6767906449167142/019d0217-0e7d-71d0-a82b-75dfe89706b0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a dresser, and access to a well-appointed bathroom and a walk-in closet.",
      "link": "false",
      "alt_text": "Bedroom with a large bed and a view into the bathroom and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (5).jpg"
    },
    {
      "id": "ec_938346c01ff04f463035b4c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-1003-7560-b5ca-4abef717cef9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
        "public_id": "019d0217-1003-7560-b5ca-4abef717cef9",
        "storage_key": "property/6767906449167142/019d0217-1003-7560-b5ca-4abef717cef9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a comfortable queen-size bed, a stylish dresser, and a spacious closet for all your storage needs.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (6).JPG"
    },
    {
      "id": "ec_30acd4542a3d729e8bc15a50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-1135-704c-ba2e-07c0077dc804.webp",
      "image_media": {
        "alt_text": "Bedroom with a twin bed, blue walls, and skateboards as decor.",
        "public_id": "019d0217-1135-704c-ba2e-07c0077dc804",
        "storage_key": "property/6767906449167142/019d0217-1135-704c-ba2e-07c0077dc804.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable twin bed, unique wall decor including skateboards, and ample closet space, perfect for a modern apartment.",
      "link": "false",
      "alt_text": "Bedroom with a twin bed, blue walls, and skateboards as decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (7).JPG"
    },
    {
      "id": "ec_9c46c42d72164270f2f0730d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-1ba9-764f-ba5a-e124586e2fea.webp",
      "image_media": {
        "alt_text": "Bathroom with dual vanity, toilet, and bathtub.",
        "public_id": "019d0217-1ba9-764f-ba5a-e124586e2fea",
        "storage_key": "property/6767906449167142/019d0217-1ba9-764f-ba5a-e124586e2fea.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a dual vanity with ample counter space, a private toilet area, and a full bathtub with shower.",
      "link": "false",
      "alt_text": "Bathroom with dual vanity, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (8).jpg"
    },
    {
      "id": "ec_e75d3996483a0110fde7d82c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-1bee-7756-82a4-b8a65d458695.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub.",
        "public_id": "019d0217-1bee-7756-82a4-b8a65d458695",
        "storage_key": "property/6767906449167142/019d0217-1bee-7756-82a4-b8a65d458695.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a single vanity, toilet, and bathtub with shower.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (9).jpg"
    },
    {
      "id": "ec_5e2bfa59aed408443489a3c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-2069-769f-885b-8f3bc3ad9d7d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019d0217-2069-769f-885b-8f3bc3ad9d7d",
        "storage_key": "property/6767906449167142/019d0217-2069-769f-885b-8f3bc3ad9d7d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for sunny days and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (10).jpg"
    },
    {
      "id": "ec_b4104fe190d78b2b777eb872",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-2163-757c-b538-d9a5d8435f4b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa area with lounge chairs and palm trees.",
        "public_id": "019d0217-2163-757c-b538-d9a5d8435f4b",
        "storage_key": "property/6767906449167142/019d0217-2163-757c-b538-d9a5d8435f4b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and spa, perfect for relaxing and soaking up the sun. Ample lounge chairs and tropical palm trees create a serene oasis.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and spa area with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (11).jpg"
    },
    {
      "id": "ec_6d06e2e332f45c85b7d912cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-28d7-72af-b9c7-d90668b41528.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana at apartment complex.",
        "public_id": "019d0217-28d7-72af-b9c7-d90668b41528",
        "storage_key": "property/6767906449167142/019d0217-28d7-72af-b9c7-d90668b41528.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the poolside at our stunning resort-style pool. Perfect for sunny days and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (12).jpg"
    },
    {
      "id": "ec_0aa568f96999d7c5f1482dbc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-28c6-72f8-9974-25d485cc9d24.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and patio area with tables and chairs.",
        "public_id": "019d0217-28c6-72f8-9974-25d485cc9d24",
        "storage_key": "property/6767906449167142/019d0217-28c6-72f8-9974-25d485cc9d24.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool and enjoy the California sunshine. Plenty of lounge chairs and seating areas available for residents.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and patio area with tables and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (13).jpg"
    },
    {
      "id": "ec_0fdcd4b7d2c2f0d55cddee1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-2d80-7105-a05f-9696bc1c17d5.webp",
      "image_media": {
        "alt_text": "Treadmills and weight machines in a modern fitness center.",
        "public_id": "019d0217-2d80-7105-a05f-9696bc1c17d5",
        "storage_key": "property/6767906449167142/019d0217-2d80-7105-a05f-9696bc1c17d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring state-of-the-art cardio machines and free weights.",
      "link": "false",
      "alt_text": "Treadmills and weight machines in a modern fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (14).JPG"
    },
    {
      "id": "ec_7c2a4b11f82decb24a360167",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-2eef-7468-9caa-7da9b575da23.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines and a view of the pool.",
        "public_id": "019d0217-2eef-7468-9caa-7da9b575da23",
        "storage_key": "property/6767906449167142/019d0217-2eef-7468-9caa-7da9b575da23.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment and a view of the sparkling pool.",
      "link": "false",
      "alt_text": "Gym with cardio machines and a view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (15).JPG"
    },
    {
      "id": "ec_721cc886fc3b8fec090450b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-340f-7523-8f45-13e32d49fd06.webp",
      "image_media": {
        "alt_text": "Elegant communal lounge area with comfortable seating and a kitchen island.",
        "public_id": "019d0217-340f-7523-8f45-13e32d49fd06",
        "storage_key": "property/6767906449167142/019d0217-340f-7523-8f45-13e32d49fd06.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed communal lounge, featuring plush seating and a convenient kitchen island.",
      "link": "false",
      "alt_text": "Elegant communal lounge area with comfortable seating and a kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (16).JPG"
    },
    {
      "id": "ec_4ca4a693cd819579fc673928",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-3549-7400-86d5-80e6efe14606.webp",
      "image_media": {
        "alt_text": "Dining area and living room in a staged apartment with a table, chairs, sofa, and decor.",
        "public_id": "019d0217-3549-7400-86d5-80e6efe14606",
        "storage_key": "property/6767906449167142/019d0217-3549-7400-86d5-80e6efe14606.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the comfortable and stylish living spaces in our apartments, featuring a well-appointed dining area and a cozy living room, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Dining area and living room in a staged apartment with a table, chairs, sofa, and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (17).JPG"
    },
    {
      "id": "ec_1d3c233e85f4fbdd6fda98a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-3ca3-741d-a062-6bf63606ede1.webp",
      "image_media": {
        "alt_text": "Conference room with large table and chairs, whiteboard, and exit sign.",
        "public_id": "019d0217-3ca3-741d-a062-6bf63606ede1",
        "storage_key": "property/6767906449167142/019d0217-3ca3-741d-a062-6bf63606ede1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Conduct business or host meetings in our well-equipped conference room.",
      "link": "false",
      "alt_text": "Conference room with large table and chairs, whiteboard, and exit sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (18).JPG"
    },
    {
      "id": "ec_9b5817080ba781095bf8cc9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-3e0b-7368-a08a-f8c2d436b26f.webp",
      "image_media": {
        "alt_text": "Community business center with computers and printer.",
        "public_id": "019d0217-3e0b-7368-a08a-f8c2d436b26f",
        "storage_key": "property/6767906449167142/019d0217-3e0b-7368-a08a-f8c2d436b26f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our business center, featuring computers and a printer for resident use.",
      "link": "false",
      "alt_text": "Community business center with computers and printer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (19).JPG"
    },
    {
      "id": "ec_58b980cc7f0b413bc7e3d543",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-4091-774f-8f77-3962eb0c6428.webp",
      "image_media": {
        "alt_text": "Exterior view of the Frisco Apartment Homes leasing center entrance with landscaping and parking.",
        "public_id": "019d0217-4091-774f-8f77-3962eb0c6428",
        "storage_key": "property/6767906449167142/019d0217-4091-774f-8f77-3962eb0c6428.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Frisco Apartment Homes, where you can find your perfect living space. Explore our beautiful community and leasing center today.",
      "link": "false",
      "alt_text": "Exterior view of the Frisco Apartment Homes leasing center entrance with landscaping and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (20).jpg"
    },
    {
      "id": "ec_a4884b7f486463f165a2b744",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-4395-73bc-b383-92d9337497fc.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and palm trees.",
        "public_id": "019d0217-4395-73bc-b383-92d9337497fc",
        "storage_key": "property/6767906449167142/019d0217-4395-73bc-b383-92d9337497fc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Covered parking spaces and the exterior of an apartment building featuring Spanish-style architecture.",
      "link": "false",
      "alt_text": "Apartment building exterior with covered parking and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (21).jpg"
    },
    {
      "id": "ec_c7c4058d4cd4deda8003e8b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-4912-7133-8abe-17066ba2d9fd.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and swings in front of apartment buildings.",
        "public_id": "019d0217-4912-7133-8abe-17066ba2d9fd",
        "storage_key": "property/6767906449167142/019d0217-4912-7133-8abe-17066ba2d9fd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and swings for residents of all ages.",
      "link": "false",
      "alt_text": "Playground equipment with slides and swings in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (22).JPG"
    },
    {
      "id": "ec_cdf7e7a1d86d3553b77bad07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-4a42-715f-adc2-bb5702687442.webp",
      "image_media": {
        "alt_text": "Fresco Apartment Homes monument sign with landscaping",
        "public_id": "019d0217-4a42-715f-adc2-bb5702687442",
        "storage_key": "property/6767906449167142/019d0217-4a42-715f-adc2-bb5702687442.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Welcome to Fresco Apartment Homes, featuring lush landscaping and a prominent monument sign. Experience our beautiful community entrance.",
      "link": "false",
      "alt_text": "Fresco Apartment Homes monument sign with landscaping",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Fresco_Favorites (23).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1e3296f5-b884-48e7-838d-b9bff6ba00e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "23035 Hemlock Ave, Moreno Valley, CA 92557, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious food and provides friendly and fast service. They also highlight the classic In-N-Out taste and the efficient staff who keep the lines moving, even during peak hours.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.in-n-out.com/44",
      "poi_directions_map_url": "https://maps.google.com/?cid=16056191596360804414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.9421386",
      "poi_longitude": "-117.2601545",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a3c-738c-b4f4-2c959457acf8",
        "storage_key": "property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1o8ZuRJ6IARPqiyAjAN094",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_fbe2e25f-7552-45f9-9bc6-aad82b6d488a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "22690 Centerpoint Dr, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including excellent prime rib, and offers generous portions. They also highlight the lively, welcoming atmosphere, the friendly and attentive staff, and the iconic fresh-baked bread with cinnamon butter.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-dbfe-7007-bfb4-d03a56c03ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-dbfe-7007-bfb4-d03a56c03ec6",
        "storage_key": "property/6767906449167142/019d0217-dbfe-7007-bfb4-d03a56c03ec6.webp",
        "width": 1280,
        "height": 758
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/california/morenovalley?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=14056647902467653292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.94023",
      "poi_longitude": "-117.2668401",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 951-421-0038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a3c-738c-b4f4-2c959457acf8",
        "storage_key": "property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX-rQ7Op3IARrP5Sv8o-E8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_930582e9-ef31-4112-be5e-3c5cf2a6e7e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Portillo's Moreno Valley",
      "poi_type": "Restaurants",
      "poi_address": "12840 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_long_description": "People say this fast food restaurant serves delicious Italian beef sandwiches, Chicago dogs, and chocolate cake shakes. They highlight the fun, nostalgic atmosphere and the fast, efficient service. They also like the generous portions and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0217-e7b8-733f-9cc5-ed221e34a106.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-e7b8-733f-9cc5-ed221e34a106",
        "storage_key": "property/6767906449167142/019d0217-e7b8-733f-9cc5-ed221e34a106.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portillos.com/locations/moreno-valley/?utm_source=google&utm_medium=yext&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8280577726960812556&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portillos-moreno-valley",
      "poi_latitude": "33.934499",
      "poi_longitude": "-117.2782796",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 951-653-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a3c-738c-b4f4-2c959457acf8",
        "storage_key": "property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhTEH6lev3IARDMKC_pGF6nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cd2f8e46-6cbd-4bac-9865-58f554a4a12e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2885 Canyon Springs Pkwy, Riverside, CA 92507, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, waffle fries, and shakes. They highlight the quick service, clean restrooms, and friendly staff. They also like the lively atmosphere and the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-7b54-7091-8fb6-fe2b2e94c96c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-7b54-7091-8fb6-fe2b2e94c96c",
        "storage_key": "property/6767906449167142/019d0218-7b54-7091-8fb6-fe2b2e94c96c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/day-street?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3735299413705819366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.9393071",
      "poi_longitude": "-117.2799725",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 951-656-6503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a3c-738c-b4f4-2c959457acf8",
        "storage_key": "property/6767906449167142/019d0218-3a3c-738c-b4f4-2c959457acf8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XOjDVqv3IAR5gSpuwZz1jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f9602ab0-1089-4a70-aa0e-e88b66c76eea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Moreno Valley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "22500 Town Cir, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Old-school retail complex offering brand-name stores, a food court, a multiplex cinema & bowling.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a movie theater, and a food court. They also highlight the live music in the food court, the massage chairs, and the family-friendly amenities, such as a kids' play area and arcade.\n\nOther reviews mention the restrooms can be poorly maintained.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.morenovalleymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4650153310421277230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-mall",
      "poi_latitude": "33.9387132",
      "poi_longitude": "-117.2710454",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 951-653-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-39c4-7775-8330-e4c7c89bd59a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-39c4-7775-8330-e4c7c89bd59a",
        "storage_key": "property/6767906449167142/019d0218-39c4-7775-8330-e4c7c89bd59a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0e85WVSv3IARLlrEWsypiEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0101edaf-b9c4-4db3-bc34-5b2f2205b8b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "12880 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of items, including bulk foods, spices, produce, and seafood. They highlight the affordable prices and the convenient bulk section, which allows customers to purchase the exact amount they need. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8327926201443612084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.9337025",
      "poi_longitude": "-117.2752068",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 951-867-3066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a0b-70a0-94a4-77885421eb1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a0b-70a0-94a4-77885421eb1d",
        "storage_key": "property/6767906449167142/019d0218-3a0b-70a0-94a4-77885421eb1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3x6m_il3IARtPW2yMG8knM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_bb0122b0-f426-4210-814f-d631a7a21e73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "12255 Pigeon Pass Rd, Moreno Valley, CA 92557, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of tools and supplies. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.homedepot.com/l/Moreno-Valley/CA/Moreno-Valley/92557/616?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7077757630406817480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.9429568",
      "poi_longitude": "-117.262584",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 951-242-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-39c4-7775-8330-e4c7c89bd59a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-39c4-7775-8330-e4c7c89bd59a",
        "storage_key": "property/6767906449167142/019d0218-39c4-7775-8330-e4c7c89bd59a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI23WD6yo3IARyHa1thA_OWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_62a20adc-4168-4973-8f8c-473cb89f3c09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Ralphs Fresh Fare",
      "poi_type": "Shopping & Retail",
      "poi_address": "5225 Canyon Crest Dr, Riverside, CA 92507, USA",
      "poi_short_description": "Chain grocery offering produce, meat, alcohol & other groceries, plus a bakery & pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and cheeses, including a large selection of gourmet cheeses. They also highlight the clean and organized aisles, and the friendly and helpful staff.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ralphs.com/stores/grocery/ca/riverside/canyon-crest-town-center/703/00609?cid=loc_70300609_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15349851366448838451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ralphs-fresh-fare",
      "poi_latitude": "33.9559152",
      "poi_longitude": "-117.3321577",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-784-3123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3a0b-70a0-94a4-77885421eb1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3a0b-70a0-94a4-77885421eb1d",
        "storage_key": "property/6767906449167142/019d0218-3a0b-70a0-94a4-77885421eb1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTSfTrGv3IARMzc6pH2gBdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_596ae784-0b6b-4378-ad9a-c7d601dd0c25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "University of California, Riverside",
      "poi_type": "Education",
      "poi_address": "900 University Ave, Riverside, CA 92521, USA",
      "poi_short_description": "This inland campus of the public research school is known for engineering & education.",
      "poi_long_description": "This inland campus of the public research school is known for engineering & education.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ucr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1154341933094673713&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-california-riverside",
      "poi_latitude": "33.9737055",
      "poi_longitude": "-117.3280644",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-827-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4005-7795-9295-76fe8feb91ef",
        "storage_key": "property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs5-qh0au3IARMR1yR98LBRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1a69a61a-ea03-453c-80c2-e61a434b5a8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Moreno Valley College",
      "poi_type": "Education",
      "poi_address": "16130 Lasselle St, Moreno Valley, CA 92551, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mvc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5019517334868949504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-college",
      "poi_latitude": "33.886786",
      "poi_longitude": "-117.2029323",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 951-571-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4005-7795-9295-76fe8feb91ef",
        "storage_key": "property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiQi-nxCn3IARAHrH6GvoqEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8c0a8849-2986-4c22-a5ac-c80f58f2ba3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Student Success Center - UCR",
      "poi_type": "Education",
      "poi_address": "Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-7c58-7696-9c79-20d25cc3582b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-7c58-7696-9c79-20d25cc3582b",
        "storage_key": "property/6767906449167142/019d0218-7c58-7696-9c79-20d25cc3582b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ae.ucr.edu/projects/student-success-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3526585288073623340&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "student-success-center---ucr",
      "poi_latitude": "33.9742375",
      "poi_longitude": "-117.3305575",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4005-7795-9295-76fe8feb91ef",
        "storage_key": "property/6767906449167142/019d0218-4005-7795-9295-76fe8feb91ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrbq_o-Ov3IARLDe_haLy8DA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7ab93933-6c53-4796-a966-d10af485e0a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "March Field Air Museum",
      "poi_type": "Entertainment",
      "poi_address": "22550 Van Buren Boulevard, Riverside, CA 92518, USA",
      "poi_short_description": "Museum with more than 70 historic military aircrafts on display including rare operational jets.",
      "poi_long_description": "People say this army museum offers an amazing collection of military aircraft, including the SR-71 Blackbird, and other associated memorabilia. They highlight the authentic and informative exhibits, the opportunity to get up close to the planes, and the spacious layout with demonstration areas. They also like the friendly, helpful, and knowledgeable staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-0922-72c8-83dd-818367d1c48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-0922-72c8-83dd-818367d1c48e",
        "storage_key": "property/6767906449167142/019d0218-0922-72c8-83dd-818367d1c48e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.marchfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7522693662382761831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "march-field-air-museum",
      "poi_latitude": "33.882707",
      "poi_longitude": "-117.266674",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 951-902-5949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4204-702d-b477-ba5ea4742804.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4204-702d-b477-ba5ea4742804",
        "storage_key": "property/6767906449167142/019d0218-4204-702d-b477-ba5ea4742804.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YxPByik3IARZydobAf6ZWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d8a7a5d6-2ff5-4eaf-b6ae-09601b0bd3e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "22550 Town Cir, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.skyzone.com/moreno-valley-ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7744140354548553552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "33.9378665",
      "poi_longitude": "-117.2696324",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYwYfHyv3IARUFeiS5-2eGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a1254492-f84d-4837-a40c-c8724077b299",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Peter J. Weber House",
      "poi_type": "Entertainment",
      "poi_address": "1510 University Ave #4468, Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://oldriverside.org/the-weber-house/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18316630069900037214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peter-j-weber-house",
      "poi_latitude": "33.9751648",
      "poi_longitude": "-117.3445741",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-289-0089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezppEDyu3IARXkyhvgC-Mf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_81339548-5845-44e6-ba23-6b6b7373b040",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Victoria Bridge",
      "poi_type": "Entertainment",
      "poi_address": "Victoria Ave., Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17150349469405624974&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "victoria-bridge",
      "poi_latitude": "33.9620485",
      "poi_longitude": "-117.3704103",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-sgfw6x3IARjjq72flHAu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_0d16f4de-398c-4a2f-aee4-69e7ae902ac8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "War Dog Memorial",
      "poi_type": "Entertainment",
      "poi_address": "March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022417975054984098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "war-dog-memorial",
      "poi_latitude": "33.8832304",
      "poi_longitude": "-117.2668896",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4204-702d-b477-ba5ea4742804.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4204-702d-b477-ba5ea4742804",
        "storage_key": "property/6767906449167142/019d0218-4204-702d-b477-ba5ea4742804.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxH9pq6n3IARomPEVKl9HPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e665088c-0446-4e5d-88b3-6549ad4a4a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "335 E Alessandro Blvd, Riverside, CA 92508, USA",
      "poi_short_description": "New gym featuring a cinema for cardio workouts, plus weights and an array of classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, resistance machines, cardio equipment, and turf areas, as well as amenities like a sauna, pool, and movie room. They highlight the affordable membership options, the clean and spacious facility, and the positive and motivating atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.eosfitness.com/gym/riverside-trautwein-rd-alessandro-blvd?utm_source=local&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18121047957985323169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.9137146",
      "poi_longitude": "-117.3268708",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 951-801-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1_tUual3IARoWiIvRvlevs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9b288553-bd1c-4932-bb9e-6c521da39502",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12660 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Fitness center featuring an indoor pool and a basketball court, along with a sauna.",
      "poi_long_description": "Some gym goers say this gym is clean and the staff is helpful and friendly.\n\nOther reviews mention the pool can be cold and the spa can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-2114-76aa-9303-e007b47e5ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-2114-76aa-9303-e007b47e5ed9",
        "storage_key": "property/6767906449167142/019d0218-2114-76aa-9303-e007b47e5ed9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/moreno-valley-ca/moreno-valley-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=10975493702316997884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "33.9369522",
      "poi_longitude": "-117.275712",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 951-571-8335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbeMeVev3IAR_DwkIV_JUJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3072f268-a57d-4ad3-91cc-97bc10c3cc3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12625 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Spacious chain gym featuring free weights, workout machines, tanning and massage options.",
      "poi_long_description": "People say this gym is clean and has friendly staff. They also highlight the good value for the money and the judgement-free, drama-free atmosphere.\n\nSome reviews mention the equipment can be in need of repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-1e03-777c-91fd-2d19dc6f9331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-1e03-777c-91fd-2d19dc6f9331",
        "storage_key": "property/6767906449167142/019d0218-1e03-777c-91fd-2d19dc6f9331.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/moreno-valley-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6982029411754891002&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.936984",
      "poi_longitude": "-117.2649215",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 951-697-8445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyqa0wGm3IAR-tb68sEm5WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3b73ef1a-d0d6-4eef-a5a5-749a953b4eb2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2600 Canyon Springs Pkwy, Riverside, CA 92507, USA",
      "poi_short_description": "Chain health club featuring state-of-the-art equipment, classes, and pools, plus basketball, and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-81df-7456-b569-941e7b77274f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-81df-7456-b569-941e7b77274f",
        "storage_key": "property/6767906449167142/019d0218-81df-7456-b569-941e7b77274f.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=315&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6186879061249781166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.9429462",
      "poi_longitude": "-117.2861652",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 951-653-3240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeECrVyv3IARrm0YCro13FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_258f1fe7-2f9f-472b-aa4a-d4e1aedaa7fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Fitness Mania",
      "poi_type": "Health and Wellness",
      "poi_address": "8719 Trautwein Rd, Riverside, CA 92508, USA",
      "poi_short_description": "Family-owned, 24/7 gym featuring a running track, a cafe, and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-824f-747e-ad61-5b155d4af422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-824f-747e-ad61-5b155d4af422",
        "storage_key": "property/6767906449167142/019d0218-824f-747e-ad61-5b155d4af422.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fitnessmaniagym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=762782383190009039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-mania",
      "poi_latitude": "33.8907435",
      "poi_longitude": "-117.3268467",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-776-9375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzcCWBhml3IARz2T3PonylQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aad22b65-d0aa-46c1-9f8f-199d43574bf8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Vim + Vigor Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5225 Canyon Crest Dr, Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including a sauna, steam room, and cold plunge. They highlight the clean facilities, spacious layout, and the friendly, welcoming atmosphere. They also like the helpful and supportive staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://vnvfit.com/locations/canyon-crest?utm_campaign=Google%20Business%20Profile&utm_source=ppc&utm_medium=Canyon%20Crest%20-%20SoCi%20GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=13768026161771995789&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vim--vigor-fitness",
      "poi_latitude": "33.9566113",
      "poi_longitude": "-117.3324971",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-683-1847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUY-v_qv3IARjWK0FtnaEb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bd8ca892-129a-4ce7-ba97-caa3f1683743",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Riverside University Health System Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "26520 Cactus Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-153b-77d7-89ff-7f281c27ac28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-153b-77d7-89ff-7f281c27ac28",
        "storage_key": "property/6767906449167142/019d0218-153b-77d7-89ff-7f281c27ac28.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ruhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13130308091680572376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside-university-health-system-medical-center",
      "poi_latitude": "33.91215650000001",
      "poi_longitude": "-117.1960001",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 951-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-446d-71ec-aabc-8624b053b94c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-446d-71ec-aabc-8624b053b94c",
        "storage_key": "property/6767906449167142/019d0218-446d-71ec-aabc-8624b053b94c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-Om45-n3IAR2MMOXKQ5OLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_236c6a00-807a-49f3-965f-9a7e72a11b1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Kaiser Permanente Moreno Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "27300 Iris Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-153b-77d7-89ff-83d0f957d598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-153b-77d7-89ff-83d0f957d598",
        "storage_key": "property/6767906449167142/019d0218-153b-77d7-89ff-83d0f957d598.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/southern-california/facilities/Moreno-Valley-Medical-Center-300019",
      "poi_directions_map_url": "https://maps.google.com/?cid=15010169944161353901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-moreno-valley-medical-center",
      "poi_latitude": "33.896939",
      "poi_longitude": "-117.1858619",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 833-574-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-446d-71ec-aabc-8624b053b94c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-446d-71ec-aabc-8624b053b94c",
        "storage_key": "property/6767906449167142/019d0218-446d-71ec-aabc-8624b053b94c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X9hiGin3IARrYD7cwnWTtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_51f1350b-1607-4f3e-8ed5-9ce14bd00deb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Sycamore Highlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sycamore Highlands Park, 5777, 5777 Fair Isle Dr, Riverside, CA 92507, USA",
      "poi_short_description": "Rolling neighborhood park with children's play & picnic areas & scenic footpaths.",
      "poi_long_description": "People say this park offers stunning panoramic views of the city, especially at sunset. They highlight the clean and well-maintained environment, and the calm, peaceful vibe. They also like the small play area for children and the opportunity for picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-858a-70ae-943d-482f7c154949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-858a-70ae-943d-482f7c154949",
        "storage_key": "property/6767906449167142/019d0218-858a-70ae-943d-482f7c154949.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "http://www.cityofriverside.org/park_rec/sycamorehighland.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6131170543388971638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sycamore-highlands-park",
      "poi_latitude": "33.9469679",
      "poi_longitude": "-117.3091251",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-436e-76dd-aeb0-51d1ef0fa738",
        "storage_key": "property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZGrWguv3IARdtIJ-B9LFlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_32313c60-ad00-4b76-b4f3-255ae333eda3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Andulka Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5201 Chicago Ave, Riverside, CA 92507, USA",
      "poi_short_description": "Tennis center with 10 championship courts along with lessons, programs & a full-service pro shop.",
      "poi_long_description": "People say this park offers baseball fields, basketball courts, tennis courts, a playground, and a walking track. They highlight the spaciousness, clean facilities, and family-friendly atmosphere. They also like the ample parking and availability of water fountains with dog bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-8817-705c-a435-a185e10c2fb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-8817-705c-a435-a185e10c2fb7",
        "storage_key": "property/6767906449167142/019d0218-8817-705c-a435-a185e10c2fb7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.riversideca.gov/park_rec/programs-sports/sports/adult/andulka-park-tennis-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715413612421745516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "andulka-park",
      "poi_latitude": "33.9575529",
      "poi_longitude": "-117.3477166",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 951-826-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-436e-76dd-aeb0-51d1ef0fa738",
        "storage_key": "property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJceVLSM2v3IARbItkvjQV1IY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8d399338-5a2b-49a3-8c2b-696724388f45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Orange Terrace Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20010 Orange Terrace Pkwy, Riverside, CA 92508, USA",
      "poi_short_description": "This community park offers baseball & softball fields, a basketball court, picnic area & playground.",
      "poi_long_description": "Visitors say this park offers a variety of activities for kids, including sports fields, playgrounds, and walking paths, and they appreciate that it's clean and well-maintained. They also highlight the peaceful atmosphere and ample parking.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.riversideca.gov/park_rec/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12366916443859875504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "orange-terrace-community-park",
      "poi_latitude": "33.895524",
      "poi_longitude": "-117.312224",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-826-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-436e-76dd-aeb0-51d1ef0fa738",
        "storage_key": "property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbMLpqel3IARsHY0o_scoKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ccb169b0-9f1d-4591-8119-f8efd08098fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Canyon Crest Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "975 Country Club Dr, Riverside, CA 92506, USA",
      "poi_short_description": "Country club offers tennis, swimming, a gym & youth camps & hosts weddings & other private events.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with fast greens and well-maintained fairways, bunkers, and fringe. They also highlight the friendly and accommodating staff, and the beautiful scenery.\n\nOther reviews mention the snack shop can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-8854-761f-a4d7-516729137878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-8854-761f-a4d7-516729137878",
        "storage_key": "property/6767906449167142/019d0218-8854-761f-a4d7-516729137878.webp",
        "width": 1280,
        "height": 1166
      },
      "poi_business_url": "https://www.canyoncrestcountryclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10864456704970324973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "canyon-crest-country-club",
      "poi_latitude": "33.9482306",
      "poi_longitude": "-117.3336276",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-274-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-9952-76d4-a641-c3a5c84cf9af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9952-76d4-a641-c3a5c84cf9af",
        "storage_key": "property/6767906449167142/019d0218-9952-76d4-a641-c3a5c84cf9af.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZhrQLmv3IAR7ftdkc9NxpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_e3f8646b-211b-406d-8de1-2233cc7f2ca1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Moreno Valley Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13380 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Soccer fields & a playground, plus a picnic area with tables, BBQ grills & a snack bar.",
      "poi_long_description": "People say this park offers a skate park, soccer fields, and tables with grills. They also highlight the spacious layout, ample parking, and shade provided by trees.\n\nOther reviews mention the restrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-23e8-723d-95c6-df874a763358.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-23e8-723d-95c6-df874a763358",
        "storage_key": "property/6767906449167142/019d0218-23e8-723d-95c6-df874a763358.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "http://www.moreno-valley.ca.us/resident_services/park_rec/index_park-rec.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=9693648778231650313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-community-park",
      "poi_latitude": "33.9264129",
      "poi_longitude": "-117.2600245",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 951-413-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-436e-76dd-aeb0-51d1ef0fa738",
        "storage_key": "property/6767906449167142/019d0218-436e-76dd-aeb0-51d1ef0fa738.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2RPag-m3IARCZjlYzTChoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7def78f9-a49e-49ad-b29d-904a7d445d53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Moreno Valley / March Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "14160 Meridian Pkwy, Riverside, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-2e3d-77f9-bd5d-3e63102d784d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-2e3d-77f9-bd5d-3e63102d784d",
        "storage_key": "property/6767906449167142/019d0218-2e3d-77f9-bd5d-3e63102d784d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.metrolinktrains.com/rider-info/general-info/stations/moreno-valleymarch-field/",
      "poi_directions_map_url": "https://maps.google.com/?cid=205875228457224281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley--march-field",
      "poi_latitude": "33.9131625",
      "poi_longitude": "-117.2883569",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-371-5465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4627-732c-96cf-68fcab10d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4627-732c-96cf-68fcab10d541",
        "storage_key": "property/6767906449167142/019d0218-4627-732c-96cf-68fcab10d541.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0EzMeul3IARWcg-9G1q2wI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_df8a96ab-89cc-4dc4-b107-055ceb3c2d3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Riverside - Hunter Park / UCR",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Marlborough Ave, Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-8c30-70cc-946b-156df07ba953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-8c30-70cc-946b-156df07ba953",
        "storage_key": "property/6767906449167142/019d0218-8c30-70cc-946b-156df07ba953.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=434339708719671602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside---hunter-park--ucr",
      "poi_latitude": "33.9986875",
      "poi_longitude": "-117.3345164",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-4627-732c-96cf-68fcab10d541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-4627-732c-96cf-68fcab10d541",
        "storage_key": "property/6767906449167142/019d0218-4627-732c-96cf-68fcab10d541.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfaIhnSu3IARMikV8qkVBwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_acdb6c1f-dae6-4941-a9c3-784d47e289e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "March ARB Visitor Control Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "363 Graeber St, March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-8d19-74ca-8cc1-4c7674de1fe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-8d19-74ca-8cc1-4c7674de1fe9",
        "storage_key": "property/6767906449167142/019d0218-8d19-74ca-8cc1-4c7674de1fe9.webp",
        "width": 1280,
        "height": 822
      },
      "poi_business_url": "https://www.march.afrc.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5383787358161936805&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "march-arb-visitor-control-center",
      "poi_latitude": "33.9093976",
      "poi_longitude": "-117.2714862",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 951-655-3791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUN1zd6l3IARpSF75RMOt0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_902235f3-4451-442c-835d-88f905a10777",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Moreno Valley City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14177 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-331e-75be-827d-6ddae4d873ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-331e-75be-827d-6ddae4d873ff",
        "storage_key": "property/6767906449167142/019d0218-331e-75be-827d-6ddae4d873ff.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.moval.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16438204615921959500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-city-hall",
      "poi_latitude": "33.9148134",
      "poi_longitude": "-117.2616433",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 951-413-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-48dc-774d-97ab-62faccd8a904.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-48dc-774d-97ab-62faccd8a904",
        "storage_key": "property/6767906449167142/019d0218-48dc-774d-97ab-62faccd8a904.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYWje3Om3IARTAI3PQE8IOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_998143a8-99bb-4504-9b8f-bea635ca399d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "UCR Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3500 Canyon Crest Dr, Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-8f20-73ef-8a9e-6d37a9b06f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-8f20-73ef-8a9e-6d37a9b06f1b",
        "storage_key": "property/6767906449167142/019d0218-8f20-73ef-8a9e-6d37a9b06f1b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://police.ucr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17671732270380703532&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ucr-police-department",
      "poi_latitude": "33.9789586",
      "poi_longitude": "-117.3309606",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-827-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbblVwEOu3IARLF_Z_d6aPvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ab36a059-0140-4d69-8cfa-ed4cfe733a4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "ID Office, March ARB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1351 Graeber St, March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-9163-758a-b450-921896a12dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-9163-758a-b450-921896a12dc6",
        "storage_key": "property/6767906449167142/019d0218-9163-758a-b450-921896a12dc6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.march.afrc.af.mil/Contact-Us/Questions/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4213828598205058450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "id-office-march-arb",
      "poi_latitude": "33.9053732",
      "poi_longitude": "-117.2678453",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 951-655-3028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbHwBtil3IARkg1lxMiGejo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b64ac2c5-9ccc-4b32-85c2-912cdf7b4a4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "custom",
      "poi_name": "Bourns Technology Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1190 Columbia Ave, Riverside, CA 92507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bourns.com/support/about-us/technology-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7937146058828997435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bourns-technology-center",
      "poi_latitude": "34.0000623",
      "poi_longitude": "-117.3368848",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 951-781-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-3e01-71d9-9439-ca1be5e64150",
        "storage_key": "property/6767906449167142/019d0218-3e01-71d9-9439-ca1be5e64150.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWzCAHWu3IARO-PkpkloJm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a5f2c9c6a171232902514fe1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b8ef1153e95b805b1fd4a78c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "WED",
      "open_time": "11:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_61e50183a6e5488bfcdb7f18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5c10be3653ba2fca6db4912f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7c36f03a4b033b47b353d1a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7a4c6e3831f965f646322fad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2492569c-afc2-44be-aae1-c914e8a49911",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "rating": "5.0",
      "name": "Naomi McSwain",
      "text": "We had been looking around at apartments for about three weeks. Fresco was by far the most organized and responsive. Property manager Kayla Johnson is awesome. I moved in this week and she has continued to be friendly, helpful, and knowledgeable, not fake or pushy. When I had a problem with my key and a neighbor in my carport spot our first day, maintenance and the security patrol addressed the issues immediately, with a follow up call the next day from Kayla. The property speaks for itself. It is lovely, clean, and surprisingly quiet. Kids play football on the grass outside my window but when I step into my apartment I can barely hear them through the double-pane glass. Our unit was spotless when we moved in and is very comfortable with nice modern carpet and wall colors. Love the large tub and bathroom! The built-in desk is my other favorite! Highly recommend Fresco.",
      "date": "2026-01-16",
      "title": ""
    },
    {
      "id": "custom_973d410f-8dbf-4c15-92ae-8bc97a4e89dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "rating": "5.0",
      "name": "Arlene Anguiano",
      "text": "So, I must admit I was waiting on giving a review since we moved here 7 months ago. The reason for that is because I really wanted to give the review that this community deserves. And for that to happen we needed to establish a little bit of time residing here.\n\nWhen we had to relocate quickly due to a house fire, and KAYLA and the whole team at FRESCO went above and beyond to support us during a very stressful time. They expedited our move-in process with compassion and efficiency, making sure we had a safe and comfortable place to land. And for that I will be forever grateful for.\n\nMaintenance has been incredibly responsive--every issue we've reported has been addressed promptly and professionally. They've also gone the extra mile to help us resolve parking issues, showing genuine concern for our comfort and convenience.\n\nBut what truly sets this community apart is the way they treat families. The care they show toward children, along with the thoughtful events they organize for back-to-school and holiday celebrations, speaks volumes about their commitment to creating a warm, welcoming environment. It's more than just a place to live--it's a place that we get to call home.\n\nWe're truly grateful for the kindness and attentiveness of the staff. It's rare to find a community that treats residents like FAMILY, and FRESCO has done just that.",
      "date": "2025-10-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_e1f1d0e5f38eea678ce2e839",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-a04c-70a7-8bd8-f9b17c3935a6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "View of an apartment living room and kitchen area with dining table, bar stools, and kitchen counter.",
        "public_id": "019d0218-a04c-70a7-8bd8-f9b17c3935a6",
        "storage_key": "property/6767906449167142/019d0218-a04c-70a7-8bd8-f9b17c3935a6.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR, 1BA - 803 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JHsXz5XmCaJ"
    },
    {
      "id": "ec_19121b9cb63ffb3f9af08ee4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0219-1c48-776f-bad3-9d556914067f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with dining area and kitchen view",
        "public_id": "019d0219-1c48-776f-bad3-9d556914067f",
        "storage_key": "property/6767906449167142/019d0219-1c48-776f-bad3-9d556914067f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1067 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XVaMfAB3uCq"
    },
    {
      "id": "ec_18b6868de19e68bb5cb966bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167142/019d0218-a07d-724d-b02b-796b5fc4c26f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with kitchen bar and dining area",
        "public_id": "019d0218-a07d-724d-b02b-796b5fc4c26f",
        "storage_key": "property/6767906449167142/019d0218-a07d-724d-b02b-796b5fc4c26f.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "3BR, 2BA - 1233 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JgwACjiZjsF"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db24b-fca5-755f-a935-3f4a9ad4265b",
      "lead_source": "LANDING_PAGE",
      "name": "Fresco Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142"
    },
    {
      "lead_collector_id": "019db24b-fe17-753d-bc29-c8c6723a5478",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Fresco Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-moreno-valley-fresco",
      "search_query": "apartments with in-unit laundry Moreno Valley",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in Moreno Valley. Experience comfort and practicality at Fresco.",
      "page_copy": "Step into the world of unparalleled convenience at Fresco, where we proudly offer apartments with in-unit laundry in Moreno Valley. Our full-size washer and dryer in each unit ensure that laundry day is stress-free and efficient, allowing you more time to enjoy our community’s amenities. Located in the vibrant Moreno Valley West neighborhood, Fresco combines modern convenience with a touch of style. \n\nBeyond the in-unit laundry, residents at Fresco enjoy thoughtfully designed interiors featuring window coverings and mirrored closet doors. The community is pet-friendly, with a dedicated Pet Play Area, and offers professional spaces like conference rooms. Choose Fresco and enjoy all the contemporary comforts in the heart of Riverside County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry",
      "seo_description": "Explore Fresco, offering in-unit laundry apartments in Moreno Valley. Enjoy modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "air-conditioning-apartments-riverside-county-fresco",
      "search_query": "apartments with air conditioning Riverside County",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments",
      "h2_subtitle": "Stay cool in Riverside County with our air-conditioned apartments. Fresco offers comfort and modern amenities in Moreno Valley.",
      "page_copy": "Beat the Riverside County heat with our air-conditioned apartments at Fresco. Experience the comfort of a cool and inviting home environment, perfect for those warm California days. Situated in Moreno Valley West, our community is the epitome of modern living, blending style and practicality. \n\nAt Fresco, each apartment comes with top-notch amenities that cater to your lifestyle. Beyond reliable air conditioning, enjoy the convenience of in-unit full-size washers and dryers, mirrored closet doors, and elegant window coverings. The community extends beyond your doorstep with a pet play area and professional conference rooms. Choose Fresco for a refreshing and comfortable living experience in Riverside County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments",
      "seo_description": "Stay cool at Fresco with air-conditioned apartments in Riverside County. Modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-park-apartments-moreno-valley-west-fresco",
      "search_query": "pet-friendly apartments with dog park Moreno Valley West",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Looking for pet-friendly apartments with a dog park in Moreno Valley West? Discover Fresco, where pets are family!",
      "page_copy": "Welcome to Fresco, where pet-friendly doesn’t just mean allowing pets—it means celebrating them. Located in the vibrant Moreno Valley West, Fresco offers apartments with a dedicated pet play area. Let your furry friend's tail wag with joy in our open spaces designed specifically for their happiness and exercise routines.\n\nOur community is thoughtfully curated to offer more than just a home; it provides a lifestyle. From the convenience of in-unit full-size washers and dryers to mirrored closet doors and stylish window coverings, everything is designed with you and your pet's comfort in mind. Choose Fresco to experience unmatched living for both you and your pets in the heart of Riverside County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Find pet-friendly apartments with a dog park at Fresco in Moreno Valley West. Enjoy modern living with your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "pool-apartments-moreno-valley-92553-fresco",
      "search_query": "apartments with pool Moreno Valley 92553",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Moreno Valley",
      "h2_subtitle": "Looking for apartments with a pool in Moreno Valley, 92553? Fresco offers the perfect spot to relax and unwind.",
      "page_copy": "Dive into a refreshing lifestyle at Fresco, located in the heart of Moreno Valley, 92553. Our apartments with a pool provide the perfect oasis for relaxation and recreation. Enjoy a swim under the Californian sun or simply soak up the serene poolside atmosphere.\n\nBeyond the pool, our community at Fresco is designed to cater to modern living needs. Each apartment features full-size in-unit washers and dryers, mirrored closet doors, and elegant window coverings. Residents also benefit from amenities such as conference rooms and a pet play area, offering a comprehensive living experience. Discover the blend of leisure and luxury at Fresco in Moreno Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Moreno Valley",
      "seo_description": "Explore poolside living at Fresco in Moreno Valley, 92553. Enjoy modern amenities and a refreshing lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "luxury-apartments-dishwasher-riverside-county-fresco",
      "search_query": "luxury apartments with dishwasher Riverside County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher",
      "h2_subtitle": "Discover luxury apartments with dishwashers in Riverside County at Fresco. Experience upscale living in Moreno Valley.",
      "page_copy": "Fresco redefines upscale living in Riverside County, offering luxury apartments equipped with dishwashers for your convenience. Nestled in the vibrant area of Moreno Valley, our community combines elegance and functionality, providing you with an exceptional living experience.\n\nOur luxurious flats don’t just stop at modern kitchen amenities. Residents enjoy full-size washers and dryers in each unit, along with mirrored closet doors, and sophisticated window coverings. The community's offerings extend to include professional conference rooms and a dedicated pet play area, ensuring a balanced lifestyle. Choose Fresco to indulge in luxury and comfort in Riverside County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher",
      "seo_description": "Fresco offers luxury apartments with dishwashers in Riverside County. Enjoy modern elegance and convenience in Moreno Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-moreno-valley-ca-fresco",
      "search_query": "one bedroom apartments moreno valley ca",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Moreno Valley",
      "h2_subtitle": "Explore one bedroom apartments in Moreno Valley, CA at Fresco. Modern comfort combined with community amenities awaits you.",
      "page_copy": "Step into comfortable living with Fresco’s one-bedroom apartments in Moreno Valley, CA. Perfectly situated in a thriving neighborhood, these units offer a delightful blend of style and convenience, making it the ideal choice for singles or couples.\n\nEach one-bedroom apartment is equipped with full-size washers and dryers, making laundry less of a chore. Additional features like mirrored closet doors and chic window coverings add a touch of luxury. Residents also enjoy access to our community amenities, such as conference rooms and a pet play area, making Fresco the perfect place to call home. Discover the charm of our charming community in the heart of Moreno Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Moreno Valley",
      "seo_description": "Discover luxury one-bedroom apartments in Moreno Valley, CA at Fresco. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-riverside-county-fresco",
      "search_query": "two bedroom apartments riverside county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Riverside County",
      "h2_subtitle": "Looking for two bedroom apartments in Riverside County? Fresco offers spacious layouts with premium amenities.",
      "page_copy": "Experience spacious living at Fresco with our two-bedroom apartments located in Riverside County. Ideal for families or roommates, these apartments offer generous floor plans designed to maximize comfort and functionality in the beautiful Moreno Valley area.\n\nEach two-bedroom unit includes modern conveniences such as full-size washers and dryers and stylish mirrored closet doors. As part of the Fresco community, residents can enjoy additional amenities like conference rooms and a pet play area, enhancing the living experience. Immerse yourself in a community that balances leisure and practicality in the heart of Riverside County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Riverside County",
      "seo_description": "Explore spacious two-bedroom apartments in Riverside County at Fresco. Perfect for families or roommates, with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167142",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-92553-fresco",
      "search_query": "three bedroom apartments near 92553",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments near 92553",
      "h2_subtitle": "Discover three bedroom apartments near 92553 at Fresco. Spacious living options make it perfect for families.",
      "page_copy": "Fresco offers three-bedroom apartments near the 92553 area, providing a perfect sanctuary for larger households. Located in Moreno Valley, this community combines spacious layouts with convenient amenities to ensure a comfortable living experience.\n\nEach three-bedroom unit features full-size washers and dryers, ensuring laundry day is hassle-free. The inclusion of mirrored closet doors and sleek window coverings adds a touch of elegance to every room. Alongside the in-home amenities, residents have access to conference rooms and a pet play area, making it ideal for both work and family life. Experience unparalleled spaciousness and style at Fresco near 92553.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments near 92553",
      "seo_description": "Explore three-bedroom apartments near 92553 at Fresco. Ideal for families, with spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308960995"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9518674787"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TMH7RBQC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "ec693b61-6471-4316-a45f-046ef2d652da"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/051a830d-965e-450b-b929-df12ef45910e/app.js?property=051a830d-965e-450b-b929-df12ef45910e&propertyName=Fresco&channelUuid=c248eabe-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47723982655"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJhd1dIRzE4bWRaQTdLcmZyNFkyd1E9PSIsInZhbHVlIjoiTXNScU00b1R4OWRpcGJBWTZSaWwzQT09IiwibWFjIjoiYmJlMGZmMTFmOWFmMjkwN2RlYTdhM2M5YWFhYjI5MGJlOGI0NGMzZGU4OWZjZjdmMzQxMjY3ZTA0MGZkNzkxYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308960995",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9518674787",
  "custom_google_gtm_id": "GTM-TMH7RBQC",
  "custom_rollout_phase": "Phase 2",
  "custom_rentgrata_token": "ec693b61-6471-4316-a45f-046ef2d652da",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/051a830d-965e-450b-b929-df12ef45910e/app.js?property=051a830d-965e-450b-b929-df12ef45910e&propertyName=Fresco&channelUuid=c248eabe-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47723982655",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJhd1dIRzE4bWRaQTdLcmZyNFkyd1E9PSIsInZhbHVlIjoiTXNScU00b1R4OWRpcGJBWTZSaWwzQT09IiwibWFjIjoiYmJlMGZmMTFmOWFmMjkwN2RlYTdhM2M5YWFhYjI5MGJlOGI0NGMzZGU4OWZjZjdmMzQxMjY3ZTA0MGZkNzkxYyJ9",
  "custom_audioeye_site_id": "466ac418-3434-43da-a3ad-5a7cb5d1f46d",
  "custom_audioeye_site_hash": "1cf8f91ca7d609b66edf311380653803"
};

export const generatedAt = '2026-10-27T17:07:27.358Z';
